<div class="d-flex align-items-center">
  @if (icon) {
    <mat-icon [svgIcon]="icon"></mat-icon>
  }
  <div class="">
    <div class="fw-bold heading">{{ heading }}</div>
    <div class="sub-heading">
      {{ subHeading }}
    </div>
  </div>
</div>
